import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IOperationStoreCategories, IOperationStoreCategoriesDetails } from "../../models/operation-store-categories/response";
import { IOperationStoreCategoriesQuery } from "../../models/operation-store-categories/query";
import { ICreateOperationStoreCategories, IUpdateOperationStoreCategories } from "../../models/operation-store-categories/request";

export type OperationStoreCategoriesLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: OperationStoreCategoriesLoading[];

  list?: IBaseListingResponse<IOperationStoreCategories>;
  query: IOperationStoreCategoriesQuery;

  details?: IOperationStoreCategoriesDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IOperationStoreCategoriesDetails) => void;

    createOperationStoreCategories: (request: ICreateOperationStoreCategories) => void;
    updateOperationStoreCategories: (id: number, request: IUpdateOperationStoreCategories) => void;
    deleteOperationStoreCategories: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: IOperationStoreCategoriesQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createOperationStoreCategories: DEFAULT_FUNCTION,
    updateOperationStoreCategories: DEFAULT_FUNCTION,
    deleteOperationStoreCategories: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const OperationStoreCategoriesContext = createContext(externalState);

export default OperationStoreCategoriesContext;